import React from "react";
import styles from "./Item.module.scss";

export default function Item({
  id,
  children,
  className = "",
  variant = "tab",
  isActive = false,
  toggleDisabled,
  ...rest
}) {
  return (
    <button
      className={`${className} col ${variant == "tab" ? styles.tabItem : `${styles.pillItem} h-100 `} ${
        isActive ? "active" : ""
      } nav-link`}
      id={`${id}-tab`}
      data-bs-toggle={!toggleDisabled && variant}
      data-bs-target={`#${id}`}
      role="tab"
      aria-controls={`nav-${id}`}
      aria-selected={isActive}
      {...rest}>
      {children}
    </button>
  );
}
